import React from "react";
import trans from "../../../utils";
import PopupBodyItem from "../../Helpers/Popup/PopupParts/PopupBodyItem";

export default function POIsContact({ poidetails }) {
	return (
		<div>
			<p className="fs-16 fw-500 brand-700 text-uppercase">
				{trans("Location Details")}
			</p>
			<div className="row">
				<div className="col-lg-12">
					<div className="display-border">
						<PopupBodyItem
							title={trans("customer name")}
							item={poidetails?.clientName ? poidetails?.clientName : "- - - -"}
						/>
						<PopupBodyItem
							title={trans("contact name")}
							item={
								poidetails?.contactPerson !== null
									? poidetails?.contactPerson?.name
									: "- - - - "
							}
						/>
						<PopupBodyItem
							title={trans("contact phone")}
							item={
								poidetails?.contactPerson !== null
									? poidetails?.contactPerson?.phone
									: "- - - - "
							}
						/>
						<PopupBodyItem
							title={trans("contact email")}
							item={
								poidetails?.contactPerson !== null
									? poidetails?.contactPerson?.email
									: "- - - - "
							}
						/>
					</div>
				</div>
			</div>
			{poidetails?.workingHours?.length > 0 && (
				<p className="fs-16 fw-500 brand-700 text-uppercase">
					{trans("Working Hours")}
				</p>
			)}
			<div className="row">
				<div className="col-lg-12">
					{poidetails?.workingHours?.map((i, index) => (
						<div key={index} className="display-border">
							<div className="flex-between border-bottom popupbody-item">
								<div className={`fs-16 fw-400 neutral-400 text-capitalize`}>
									{trans(i.day)}
								</div>
								<div className="flex-between">
									<div className={`fs-14 fw-500 text-capitalize `}>
										{i?.startTime}
									</div>
									<div className="mx-3">{trans("to")}</div>
									<div className={`fs-14 fw-500 text-capitalize `}>
										{i?.endTime}
									</div>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
